const getGraphObject = (theme) => {
  return {
    resultTrendStyle: {
      textAlign: "left",
      fontWeight: 400,
      fontSize: "24px",
      lineHeight: "32px",
      color: "#030404",
    },
    toggleButtonText: {
      padding: "10px",
      fontSize: "14px",
      lineHeight: "24px",
      letterSpacing: "0.4px",
      fontWeight: 600,
    },
  };
};

export const getGraphStyle = getGraphObject;
